import HighSchoolTrainingLandingContainer from './container'
export default HighSchoolTrainingLandingContainer
